import { useCurrentUserPermissions } from 'src/hooks/user';

import { PeosDetailsStaffTablePeoPayrollProvider } from './PeosDetailsStaffTablePeoPayrollProvider';
import { PeosDetailsStaffTablePlatformStaff } from './PeosDetailsStaffTablePlatformStaff';

interface PeosDetailsStaffTableProps {
  peoId: string | undefined;
}

export const PeosDetailsStaffTable: React.FC<PeosDetailsStaffTableProps> = ({ peoId }) => {
  const { hasPlatformRoles, isPeoPayrollProviderUser } = useCurrentUserPermissions();

  if (hasPlatformRoles) {
    return <PeosDetailsStaffTablePlatformStaff peoId={peoId} />;
  }

  if (isPeoPayrollProviderUser) {
    return <PeosDetailsStaffTablePeoPayrollProvider peoId={peoId} />;
  }

  return null;
};
